import { Dialog } from '@headlessui/react'
import { useLayoutEffect } from 'react'

import NotifyIcon from '../../../assets/images/icons/add-url-notify.svg?react'
import XIcon from '../../../assets/images/icons/x-close-filter.svg?react'
import { useFastFetchNotifyMutation } from '../../../store/api/product'
import { useFastFetchModal } from '../../../utils/context/modal/use-fast-fetch-modal'
import ManageTableCheckbox from '../../../utils/forms/checkbox/manage-table-checkbox'

type AppPropsDialog = {}

function AddUrlFastFetchModal({}: AppPropsDialog) {
  const [notifyFastFetch] = useFastFetchNotifyMutation()
  const {
    isOpen,
    close,
    trackerId,
    setTrackerId,
    competitorName,
    setCompetitorName,
    isMine,
    doNotShow,
    onCheckboxChange,
    savedScrollY,
  } = useFastFetchModal()

  useLayoutEffect(() => {
    if (!isOpen) return

    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY.current}px`
    document.body.style.width = '100%'

    return () => {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, savedScrollY.current)
    }
  }, [isOpen])

  return (
    <Dialog open={isOpen} onClose={() => close()} className="relative z-50">
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{
          background: 'rgba(41, 41, 41, 0.7)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100 sm:w-[30rem] w-full">
          <div className="flex flex-col p-6 items-center">
            <button
              className="absolute right-8 active:bg-gray-50 border-0 p-2 rounded-full"
              onClick={() => close()}
            >
              <XIcon />
            </button>
            <NotifyIcon />
            <h1 className="font-medium text-lg text-gray-900 mt-5">
              URL Fast-Fetch in Progress
            </h1>
            {isMine ? (
              <p className="font-normal text-sm text-gray-500 mt-2 text-center mx-12">
                You added your own URL successfully. Price will be visible
                shortly.
              </p>
            ) : (
              <p className="font-normal text-sm text-gray-500 mt-2 text-center mx-8">
                You added the first URL of your competitor{' '}
                <p className="mx-1 break-all">{competitorName}</p>
                successfully.
              </p>
            )}
            <p className="font-normal text-sm text-gray-500 mt-6 text-center mx-4">
              Do you want to get email notification after the price fetch?
            </p>
            <div className="mt-8 flex flex-row space-x-1 items-center">
              <ManageTableCheckbox
                handleCheckboxChange={onCheckboxChange}
                isChecked={doNotShow}
              />
              <p className="font-medium text-sm text-gray-700">
                Do not show this again
              </p>
            </div>

            <div className="flex flex-row mt-8 w-full space-x-3">
              <button
                onClick={() => {
                  close()
                }}
                className="border border-solid border-gray-300 rounded-lg shadow-sm w-full h-11"
              >
                <span className="font-medium text-base text-gray-700 ">
                  No, don’t notify me
                </span>
              </button>
              <button
                type="button"
                onClick={async () => {
                  try {
                    await notifyFastFetch({
                      id: trackerId!,
                      email_subscription: doNotShow ? 1 : 0,
                    })
                  } catch (error) {
                  } finally {
                    setTrackerId(undefined)
                    setCompetitorName(undefined)
                    close()
                  }
                }}
                className="border border-solid border-primary-600 rounded-lg shadow-sm w-full h-11 bg-primary-600"
              >
                <span className="font-medium text-base text-white-100 ">
                  Yes, notify me
                </span>
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default AddUrlFastFetchModal
